<div class="bg-white">
    <div class="header">
        <div class="mt-1" style="width: 100%;">
            <h3 class="scenario_heading">
                {{"lang.scenerio.price_tier_sku_heading" | translate}}
            </h3>
            <div class="filter-fields">

                <!-- Price Band -->
                <div class="filter-field" *ngIf="pt_settings?.view_scenario">
                    <label class="category_heading"> {{"lang.scenerio.labels.price_band" | translate}} </label>
                    <p-dropdown [(ngModel)]="selected_price_band" [options]="price_band_data" (onChange)="OnPriceBandChange($event)" dataKey="geo_id"
                        optionLabel="geo_desc"  placeholder="{{ 'lang.scenerio.placeholder.all_price_bands' | translate }}" class="language font-md">
                    </p-dropdown>
                </div>

                <!-- Category -->
                <div  class="filter-field" *ngIf="scenario_filters?.category_l1">
                    <label class="category_heading" > {{"lang.scenerio.labels.category_l1" | translate}} </label>
                    <p-multiSelect [maxSelectedLabels]=1 [(ngModel)]="selected_category" [options]="category_data"
                        placeholder="{{'lang.scenerio.placeholder.category' | translate}}" dataKey="category_lvl1_id"
                        optionLabel="category_lvl1_name" class="language" #categoryL1Dropdown (onPanelHide)="onCategoryHide()">
                        <ng-template let-value pTemplate="selectedItems">
                            <div *ngIf="value?.length>1 ;  then allSelectedTemplate;else elseTemplate ">
                            </div>
                            <ng-template #allSelectedTemplate>
                                {{value.length +' '}} {{'lang.scenerio.category_selected' | translate}}
                            </ng-template>

                            <ng-template #elseTemplate>
                                <ng-template [ngIf]="value?.length ?? 0 > 0" [ngIfElse]="defaultTemplate">
                                    {{value[0].category_lvl1_name}}
                                </ng-template>
                                <ng-template #defaultTemplate>{{'lang.scenerio.placeholder.category' |
                                    translate}}</ng-template>
                            </ng-template>
                        </ng-template>
                        <ng-template pTemplate="footer">

                            <div class="category_footer d-flex justify-content-between p-2">
                                <p-button styleClass="p-button-sm cancel"
                                    (click)="onClearCategories(); categoryL1Dropdown.hide()" label="Clear"
                                    [disabled]="selected_category.length==0"></p-button>
                                <p-button styleClass="p-button-sm apply" label="Apply"
                                    (click)="applyCategoryList();categoryL1Dropdown.hide()"
                                    [disabled]="selected_category.length==0 && applied_categories.length==0"></p-button>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </div>
                                <!-- Product - Category - L2 -->
                                <div class="filter-field" *ngIf="scenario_filters?.category_l2">
                                    <label class="category_heading"> {{"lang.scenerio.labels.product_category" | translate}} </label>
                                    <p-multiSelect [maxSelectedLabels]=1 [(ngModel)]="selected_category_l2" [options]="category_l2_data"
                                        placeholder="{{'lang.scenerio.placeholder.category' | translate}}" dataKey="category_lvl2_id"
                                        optionLabel="category_lvl2_name" class="language" #categoryL2Dropdown (onPanelHide)="onCategoryHide()">
                                        <ng-template let-value pTemplate="selectedItems">
                                            <div *ngIf="value?.length>1 ;  then allSelectedTemplate;else elseTemplate ">
                                            </div>
                                            <ng-template #allSelectedTemplate>
                                                {{value.length +' '}} {{'lang.scenerio.category_selected' | translate}}
                                            </ng-template>
                
                                            <ng-template #elseTemplate>
                                                <ng-template [ngIf]="value?.length ?? 0 > 0" [ngIfElse]="defaultTemplate">
                                                    {{value[0].category_lvl2_name}}
                                                </ng-template>
                                                <ng-template #defaultTemplate>{{'lang.scenerio.placeholder.category' |
                                                    translate}}</ng-template>
                                            </ng-template>
                                        </ng-template>
                                        <ng-template pTemplate="footer">
                
                                            <div class="category_footer d-flex justify-content-between p-2">
                                                <p-button styleClass="p-button-sm cancel"
                                                    (click)="onClearL2Categories(); categoryL2Dropdown.hide()" label="Clear"
                                                    [disabled]="selected_category_l2.length==0"></p-button>
                                                <p-button styleClass="p-button-sm apply" label="Apply"
                                                    (click)="applyCategoryL2List();categoryL2Dropdown.hide()"
                                                    [disabled]="selected_category_l2.length==0 && applied_categories.length==0"></p-button>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </div>

                                <!-- Sub - Category -->
                                <div class="filter-field"  *ngIf="scenario_filters?.subcategory">
                                    <label class="category_heading"> {{"lang.scenerio.labels.sub_category" | translate}} </label>
                                    <p-multiSelect [maxSelectedLabels]=1 [(ngModel)]="selected_sub_category" [options]="sub_category_data"
                                        placeholder="{{'lang.scenerio.placeholder.category' | translate}}" dataKey="sub_category_id"
                                        optionLabel="sub_category_name" class="language" #subCategoryDropdown (onPanelHide)="onCategoryHide()">
                                        <ng-template let-value pTemplate="selectedItems">
                                            <div *ngIf="value?.length>1 ;  then allSelectedTemplate;else elseTemplate ">
                                            </div>
                                            <ng-template #allSelectedTemplate>
                                                {{value.length +' '}} {{'lang.scenerio.category_selected' | translate}}
                                            </ng-template>
                                
                                            <ng-template #elseTemplate>
                                                <ng-template [ngIf]="value?.length ?? 0 > 0" [ngIfElse]="defaultTemplate">
                                                    {{value[0].sub_category_name}}
                                                </ng-template>
                                                <ng-template #defaultTemplate>{{'lang.scenerio.placeholder.category' |
                                                    translate}}</ng-template>
                                            </ng-template>
                                        </ng-template>
                                        <ng-template pTemplate="footer">
                                
                                            <div class="category_footer d-flex justify-content-between p-2">
                                                <p-button styleClass="p-button-sm cancel" (click)="onClearSubCategories(); subCategoryDropdown.hide()" label="Clear"
                                                    [disabled]="selected_sub_category.length==0"></p-button>
                                                <p-button styleClass="p-button-sm apply" label="Apply" (click)="applySubCategoryList();subCategoryDropdown.hide()"
                                                    [disabled]="selected_sub_category.length==0 && applied_categories.length==0"></p-button>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </div>



                <!-- Product Name -->
                <div class="filter-field" *ngIf="scenario_filters?.product">
                    <label class="category_heading"> {{"lang.scenerio.labels.product_name" | translate}} </label>
                    <p-multiSelect [maxSelectedLabels]=1 [(ngModel)]="selected_product_name" [options]="product_name_data"
                        placeholder="{{'lang.scenerio.placeholder.Select_Product_Name' | translate}}" dataKey="product_id"
                        optionLabel="product_name" class="language" #productDropdown (onPanelHide)="onProductNameHide()">
                        <ng-template let-value pTemplate="selectedItems">
                            <div *ngIf="value?.length>1 ;  then allSelectedTemplate;else elseTemplate ">
                            </div>
                            <ng-template #allSelectedTemplate>
                                {{value.length +' '}} {{'lang.scenerio.products_selected' | translate}}
                            </ng-template>

                            <ng-template #elseTemplate>
                                <ng-template [ngIf]="value?.length ?? 0 > 0" [ngIfElse]="defaultTemplate">
                                    {{value[0].product_name}}
                                </ng-template>
                                <ng-template #defaultTemplate>{{'lang.scenerio.placeholder.Select_Product_Name' |
                                    translate}}</ng-template>
                            </ng-template>
                        </ng-template>
                        <ng-template pTemplate="footer">

                            <div class="category_footer d-flex justify-content-between p-2">
                                <p-button styleClass="p-button-sm cancel"
                                    (click)="onClearProductName(); productDropdown.hide()" label="Clear"
                                    [disabled]="selected_product_name.length==0"></p-button>
                                <p-button styleClass="p-button-sm apply" label="Apply"
                                    (click)="applyProductNameList();productDropdown.hide()"
                                    [disabled]="selected_product_name.length==0 && applied_product_name.length==0"></p-button>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </div>
                <div class="reset-button1" (click)="resetFliters()">
                    <button>
                        <img src="./../../assets/images/scenerio-planner/reset.svg">
                        {{"lang.scenerio.labels.reset" | translate}}
                    </button>
                </div>
                <div class="filter-field column cursor-pointer">
                        <label> {{"lang.recommendation.add_column" | translate}} </label>
                        <p-multiSelect [maxSelectedLabels]=1 [(ngModel)]="selected_column" [options]="column_data"
                            placeholder="{{'lang.common.all' | translate}}" dataKey="column_id"
                            optionLabel="column_name" class="language" #columnDropdown (onPanelHide)="onCategoryHide()">
                            <ng-template let-value pTemplate="selectedItems">
                                <div *ngIf="value?.length>=1 ;  then allSelectedTemplate;else elseTemplate ">
                                </div>
                                <ng-template #allSelectedTemplate>
                                    {{value.length +' '}} {{'lang.recommendation.column_selected' | translate}}
                                </ng-template>
    
                                <ng-template #elseTemplate>
                                    <ng-template [ngIf]="value?.length ?? 0 > 0" [ngIfElse]="defaultTemplate">
                                        {{value[0].category_name}}
                                    </ng-template>
                                    <ng-template #defaultTemplate>{{'lang.common.all' |
                                        translate}}</ng-template>
                                </ng-template>
                            </ng-template>
                            <ng-template pTemplate="footer">
    
                                <div class="category_footer d-flex justify-content-between p-2" >
                                    <p-button styleClass="p-button-sm cancel"
                                        (click)="columnDropdown.hide(); clearSelectedColumns()" label="Clear"
                                        [disabled]="selected_column.length==0"></p-button>
                                    <p-button styleClass="p-button-sm apply" label="Apply"
                                        (click)="columnDropdown.hide(); applySelectedColumns()"
                                        [disabled]="selected_column.length==0 && applied_categories.length==0"></p-button>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                </div>
                <div class="column_breaker" *ngIf="pt_settings?.create_scenario"></div>
                <div class="filter-field download cursor-pointer" [ngStyle]="{'margin-left': pt_settings?.create_scenario? 'initial' : ''}" *ngIf="pt_settings?.create_scenario">
                    <div (click)="downloadScenario()"><img src="./../../assets/images/scenerio-planner/download.svg">{{"lang.common.download" |
                        translate}}</div>
                    <div class="breaker"></div>
                    <input hidden type="file" #uploader accept=".xlsx,.xls" (change)="uploadScenarioDto($event)" />
                    <div (click)="uploader.click()"><img src="./../../assets/images/scenerio-planner/upload.svg">{{"lang.common.upload" |
                        translate}}</div>
                </div>
            </div>
            <div class="toggle_filter">
                <div class="filter-field sku-toggle" *ngIf="pt_settings?.create_scenario">
                    <div>
                        {{"lang.scenerio.sku_with_recommended_price" | translate}}<mat-slide-toggle [(ngModel)]="is_recommended_price_change" (change)="updateTable(false, true)"></mat-slide-toggle>
                    </div>
                </div>
                <div class="filter-field sku-toggle" >
                    <div>
                        {{"lang.scenerio.sku_with_price_change" | translate}}<mat-slide-toggle [(ngModel)]="is_price_change" [disabled]="pt_settings?.create_scenario && !is_alert_toggle_disabled" (change)="updateTable(false, true)"  ></mat-slide-toggle>
                    </div>
                </div>
                <div class="filter-field sku-toggle" *ngIf="pt_settings?.create_scenario">
                    <div>
                        {{"lang.scenerio.sku_with_alert" | translate}}<mat-slide-toggle [(ngModel)]="is_producted_affected" [disabled]="!is_alert_toggle_disabled" (change)="updateTable(false, true)"  ></mat-slide-toggle>
                    </div>
                </div>
                <div class="filter-field sku-toggle" *ngIf="pt_settings?.create_scenario">
                    <div>
                        {{"lang.scenerio.new_product_lto" | translate}} <mat-slide-toggle [(ngModel)]="price_analysis_required"  (change)="updateTable(false, true)"  ></mat-slide-toggle>
                    </div>
                </div>
                <!-- <div class="reset-button">
                    <button>
                        <img src="./../../assets/images/scenerio-planner/reset.svg">
                        {{"lang.scenerio.labels.reset" | translate}}
                    </button>
                </div> -->
            </div>
        </div>


    </div>
    <div class="col-md-12 tier-table" *ngIf="CheckForEmptyFilter()">
      <div class="table-container"  >
            <table mat-table #table matSort (matSortChange)="sortData($event)" [dataSource]="data_source">

                <!-- Price Tier Column -->
                <ng-container matColumnDef="price_tier" [sticky]="!responsiveService.orientationPortrait()">
                    <th mat-header-cell *matHeaderCellDef class="tier-width">
                        
                        <div class="sorting_icon">
                            <span>  {{"lang.scenerio.price_tier_table.price_band" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row; let i=index">
                        {{row.price_tier}}
                    </td>
                </ng-container>

                <!-- Objective Column -->
                <ng-container matColumnDef="objective" [sticky]="!responsiveService.orientationPortrait()">
                    <th mat-header-cell *matHeaderCellDef class="tier-width">
                        
                        <div class="sorting_icon">
                            <span> {{"lang.scenerio.price_tier_table.objective" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row; let i=index">
                        {{row.objective}}
                    </td>
                </ng-container>

                <!-- Category L1 Column -->
                <ng-container matColumnDef="category_l1" [sticky]="!responsiveService.orientationPortrait()">
                    <th mat-header-cell *matHeaderCellDef>
                      
                        <div class="sorting_icon" *ngIf="scenario_filters?.category_l1">
                            <span>   {{"lang.scenerio.labels.category_l1" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row"> 
                      <span *ngIf="scenario_filters?.category_l1">  {{row.category_lvl1_name}} </span>
                    </td>
                </ng-container>

                                <!-- Category L2 Column -->
                                <ng-container matColumnDef="category_l2" [sticky]="!responsiveService.orientationPortrait()">
                                    <th mat-header-cell *matHeaderCellDef>
                                      
                                        <div class="sorting_icon" *ngIf="scenario_filters?.category_l2">
                                            <span>   {{"lang.scenerio.labels.product_category" | translate}}</span>
                                            <div mat-sort-header disableClear>
                                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                                            </div>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let row"> 
                                        <span *ngIf="scenario_filters?.category_l2">  {{row.category_lvl2_name}} </span> 
                                    </td>
                                </ng-container>

                                                <!-- Sub Category  Column -->
                <ng-container matColumnDef="sub_category" [sticky]="!responsiveService.orientationPortrait()">
                    <th mat-header-cell *matHeaderCellDef>
                      
                        <div class="sorting_icon" *ngIf="scenario_filters?.subcategory">
                            <span>   {{"lang.scenerio.labels.sub_category" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row"> 
                        <span *ngIf="scenario_filters?.subcategory">  {{row.sub_category_name}} </span>
                    </td>
                </ng-container>

                <!-- SKU ID Column -->
                <ng-container matColumnDef="sku_id" [sticky]="!responsiveService.orientationPortrait()">
                    <th mat-header-cell *matHeaderCellDef class="tier-width">
                       
                        <div class="sorting_icon" *ngIf="scenario_filters?.product">
                            <span>   {{"lang.scenerio.price_tier_table.sku_id" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row"> 
                        <span *ngIf="scenario_filters?.product">  {{row.sku_id}} </span>
                    </td>
                </ng-container>

                <!-- SKU Name Column -->
                <ng-container matColumnDef="sku_name" [sticky]="!responsiveService.orientationPortrait()">
                    <th mat-header-cell *matHeaderCellDef [ngClass]="{border_right: !responsiveService.orientationPortrait()}">
                       
                        <div class="sorting_icon" *ngIf="scenario_filters?.product">
                            <span>   {{"lang.scenerio.price_tier_table.sku_name" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" [ngClass]="{border_right: !responsiveService.orientationPortrait()}"> 
                      <div class="product_name" *ngIf="scenario_filters?.product">
                      <span> {{row.sku_name}} </span>
                      <div *ngIf="row.price_analysis_required" class="npd">
                        <img src="./../../assets/images/scenerio-planner/star.png"/>
                      </div>
                      </div>
                    </td>
                </ng-container>

                <!-- Current Price Column -->
                <ng-container matColumnDef="current_price">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span> {{"lang.scenerio.price_tier_table.current_price" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> <span *ngIf="row.current_price">{{this.utilService.getCurrencySymbol()}}</span>
                        {{priceMetricCalculationWithTwoDecimal(row.current_price)}} </td>
                </ng-container>

                <!-- Recommnded Price Column -->
                <ng-container matColumnDef="recommended_price">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span>  {{"lang.scenerio.price_tier_table.recommended_price" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> <span *ngIf="row.recommended_price">{{this.utilService.getCurrencySymbol()}}</span>
                        {{priceMetricCalculationWithTwoDecimal(row.recommended_price)}} </td>
                </ng-container>

                <!-- Final Instore Price Column -->
                <ng-container matColumnDef="scenario_price">
                    <th mat-header-cell *matHeaderCellDef>
                      
                        <div class="sorting_icon">
                            <span>   {{"lang.scenerio.price_tier_table.final_instore_price" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        <span [ngClass]="pt_settings?.view_scenario== true || pt_settings?.view_price_band_scenario == true ? '':'currency'">{{this.utilService.getCurrencySymbol()}}</span>
                        <input type="text" class="form-control instore-price" [(ngModel)]="row.scenario_price"  appTwoDigitDecimalNumber
                            (keypress)="onlyNumberKey($event)"
                            (keyup)="onValidatePriceChange(row.existing_price ,row.scenario_detail_id,$event,row)"
                            *ngIf="pt_settings?.create_scenario">
                        <span *ngIf="pt_settings?.view_scenario || pt_settings?.view_price_band_scenario == true" > {{priceMetricCalculationWithTwoDecimal(row.scenario_price)}}</span>
                    </td>
                </ng-container>

                <!-- Price Change Column -->
                <ng-container matColumnDef="price_change">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span> {{"lang.scenerio.price_tier_table.price_change" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                    <span *ngIf="!checkForNewProductValidation(row)">{{priceMetricCalculationWithPercentageDecimal(row.price_change)}}
                        <span *ngIf="!utilService.isNullOrEmptyOrUndefined(row.price_change)">%</span> <mat-icon
                            class="price-change-up-icon" *ngIf="row.price_change_ind == 1">arrow_upward</mat-icon>
                        <mat-icon class="price-change-down-icon" *ngIf="row.price_change_ind == -1">arrow_downward</mat-icon>
                    </span>
                    <span *ngIf="checkForNewProductValidation(row)"> - </span>
                    </td>
                </ng-container>

                <!-- Base Units Column -->
                <ng-container matColumnDef="base_units">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span> {{"lang.scenerio.price_tier_table.base_units" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> 
                       <span *ngIf="!checkForNewProductValidation(row)"> {{priceMetricCalculationWithThousands(row.base_units | number : '1.0-0')}} </span>
                       <span *ngIf="checkForNewProductValidation(row)"> - </span>
                    </td>
                </ng-container>

                <!-- Estmaited Price Column -->
                <ng-container matColumnDef="estimated_units_lb">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span>  {{"lang.scenerio.price_tier_table.estimated_units" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> 
                        <span *ngIf="!checkForNewProductValidation(row)">{{priceMetricCalculationWithThousands(row.estimated_units  | number : '1.0-0')}} </span>
                        <span *ngIf="checkForNewProductValidation(row)"> - </span>
                     </td>
                </ng-container>

                <!-- Weekly Margin Column -->
                <ng-container matColumnDef="gross_margin_lb">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span>  {{"lang.scenerio.price_tier_table.weekly_margin" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> 
                        <span *ngIf="!checkForNewProductValidation(row)">
                        <span *ngIf="row.gross_margin">{{this.utilService.getCurrencySymbol()}}</span>
                        {{priceMetricCalculationWithThousands(row.gross_margin) | thousandSeparator}} </span>
                        <span *ngIf="checkForNewProductValidation(row)"> - </span>
                    </td>
                </ng-container>

                <!-- Price Sensitivity Column -->
                <ng-container matColumnDef="price_sensitivity">
                    <th mat-header-cell *matHeaderCellDef>
                        
                        <div class="sorting_icon">
                            <span>  {{"lang.scenerio.price_tier_table.price_sensitivity" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"
                       >
                        <span  [ngStyle]="{ 'color': price_sensitivity_text_color[row.price_sensitivity] }">
                        <span *ngIf="checkForPriceSenstivity(row.price_sensitivity)">{{price_sensitivity[row.price_sensitivity] | translate}}</span>
                        <span *ngIf="!checkForPriceSenstivity(row.price_sensitivity)">NA</span>
                        </span>
                        <!-- <span *ngIf="checkForNewProductValidation(row)"> - </span> -->
                         </td>
                </ng-container>

                <!-- Avg Competitor Price Column -->
                <ng-container matColumnDef="avg_comp_price">
                    <th mat-header-cell *matHeaderCellDef>
                       
                        <div class="sorting_icon">
                            <span>   {{"lang.scenerio.price_tier_table.avg_competitor_price" | translate}}</span>
                            <div mat-sort-header disableClear>
                                <mat-icon class="sort-up-icon">arrow_drop_up</mat-icon>
                                <mat-icon class="sort-down-icon">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-center"> 
                        <span *ngIf="!checkForNewProductValidation(row)"><span *ngIf="row.avg_comp_price">{{this.utilService.getCurrencySymbol()}}</span>
                        {{priceMetricCalculationWithTwoDecimal(row.avg_comp_price)}}
                        </span>
                        <span *ngIf="checkForNewProductValidation(row)"> - </span>
                     </td>
                </ng-container>
 
                <tr mat-header-row *matHeaderRowDef="price_tier_table_columns; sticky: true"></tr>
                <tr [ngClass]="is_alert_toggle_disabled && row.is_product_affected ? 'alert_items' : is_alert_toggle_disabled && row.is_price_changed ? 'price_change_items' : row.price_analysis_required? '': ''" 
                    mat-row *matRowDef="let row; columns: price_tier_table_columns;"></tr>

            </table>
            </div>
            <mat-paginator #paginator (page)="pageEvent($event)" [pageIndex]="page_index" [length]="count" [pageSize]="page_size"
            [pageSizeOptions]="[10, 50, 100]" [showFirstLastButtons]="false" [hidePageSize]="false"></mat-paginator>
            <div class="no-record" *ngIf="data_source.data.length == 0">
              <span>{{'lang.scenerio.no_filter_data' | translate}}</span>
            </div>

        <div class="footer-part action_buttons" *ngIf="pt_settings?.create_scenario">
            <button class="selected" (click)="openResetToRecommendationPopup()"> {{"lang.scenerio.reset_price_recommend" |
                translate}}</button>
            <button class="selected" (click)="openResetToCurrentPopup()"> {{"lang.scenerio.reset_price_current" |
                translate}}</button>
            <button class="selected" [ngClass]="{disable_recalculate: price_hierarchy_enable}" [disabled]="price_hierarchy_enable" (click)="openPriceHierarchyPopup()"> {{"lang.scenerio.reset_price_heirarchy" | translate}}</button> 
            <button class="selected calculate-impact" [ngClass]="{disable_recalculate: !(is_file_uploaded) && (price_change.size < 1 || is_validate_price_enable)}" [disabled]="!(is_file_uploaded) && (price_change.size < 1 || is_validate_price_enable)"(click)="recalculateImpactDto('price_change','recalculate')"> {{"lang.scenerio.recalculate_impact" | translate}}</button>
        </div>

        <!-- info note about colors -->
        <div class="color-info" *ngIf="pt_settings?.create_scenario">
          <div><span>{{ "lang.scenerio.note" | translate }}</span></div>
          <div><span class="pl-2"><span class="impact_note">*</span>{{ "lang.scenerio.info_original_impact" | translate }}</span></div>
          <div><span class="pl-2"><span class="impact_note">**</span>{{ "lang.scenerio.info_estimated_impact" | translate }}</span></div>
          <div><span class="pl-2">{{ "lang.scenerio.active_product_info" | translate }}</span></div>
          <div><span class="pl-2"><span class="price_change_items">{{ "lang.scenerio.blue" | translate }}</span> - {{ "lang.scenerio.info_blue" | translate }}</span></div>
          <div><span class="pl-2"><span class="alert_items">{{ "lang.scenerio.red" | translate }}</span> - {{ "lang.scenerio.info_red" | translate }}</span></div>
          <!-- <div><span class="pl-2"><span class="price_analysis_required">{{ "lang.scenerio.red" | translate }}</span> - {{ "lang.scenerio.info_red" | translate }}</span></div> -->
        </div>

    </div>
    <div class="duration_text">
        <span> * {{"lang.common.table_duration_note" | translate}}</span>
    </div>
    <br>
</div>
<div class="save-part">
    <button class="save-button" [disabled] ="!is_item_recalculated" [ngClass]="{disable_save: !is_item_recalculated}" (click)="saveSkuLevel()" *ngIf="pt_settings?.create_scenario"> {{"lang.scenerio.save" | translate}}</button>
</div>


<!---------------------------------------- Scenario Delete Popup -------------------------------->

<div class="backdrop" [ngStyle]="{'display': sku_level_save_confirm_pupup}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':sku_level_save_confirm_pupup}">
    <!-- modal-dialog -->
    <div class="modal-dialog modal-dialog-centered" role="document">
        <!-- modal-content -->
        <div class="modal-content">
            <!-- modal-header -->
            <div class="modal-header">
                <h4 class="modal-title header_label_portal text-black mt-1 costa_text">
                    {{"lang.scenerio.new_scenario" | translate}}
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
                        aria-hidden="true">&times;</span></button>
            </div>

            <!-- modal-body -->
            <div class="modal-body cancelBody">
                <div class="new-pricing">
                    <div class="">
                        {{"lang.scenerio.create_scenario_info" | translate}}
                    </div>
                </div>
            </div>
            <!-- modal-footer -->
            <div class="modal-footer">
                <button type="button" class="cancel-btn btn btn-default table-submit button_portal mr-3"
                    (click)="closePopup()">{{'lang.common.no' | translate}}
                </button>
                <button class="settings-btn btn btn-default table-submit button_portal ok-button"
                    (click)="openNewScenarioPopup()" type="button">{{'lang.common.yes' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>


<!---------------------------------------- New Scenario Popup -------------------------------->

<div class="backdrop" [ngStyle]="{'display': sku_level_new_scenario}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':sku_level_new_scenario}">
    <!-- modal-dialog -->
    <div class="modal-dialog modal-dialog-centered" role="document">
        <!-- modal-content -->
        <div class="modal-content">
            <!-- modal-header -->
            <div class="modal-header">
                <h4 class="modal-title header_label_portal text-black mt-1 costa_text">
                    {{"lang.scenerio.new_scenario" | translate}}
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
                        aria-hidden="true">&times;</span></button>
            </div>

            <!-- modal-body -->
            <div class="modal-body cancelBody">
                <div class="new-pricing">
                    <div class="save-fields">
                        <div class="filter-field save-field">
                            <label> {{"lang.scenerio.labels.scenerio_name" | translate}}<span class="mandatory">*</span></label>
                            <input class="input" [(ngModel)]="name"
                                placeholder="{{'lang.recommendation.placeholder.scenario_name' | translate}}">
                        </div>
                        <div class="filter-field save-field mt-1">
                            <label> {{"lang.scenerio.labels.scenerio_description" | translate}}<span class="mandatory">*</span></label>
                            <textarea class="text-area" [(ngModel)]="description"
                                placeholder="{{'lang.scenerio.placeholder.scenerio_description' | translate}}"></textarea>
                        </div>
                        <div class="filter-field save-field datepicker mt-1">
                            <label>   {{"lang.price_recommendation.table_headers.planning_cycle_date" | translate}} <span class="mandatory">*</span></label>
                            <mat-form-field appearance="outline" >
                                <input matInput [placeholder]="'lang.price_recommendation.table_headers.planning_cycle_date' | translate"  [matDatepicker]="picker"  [formControl]="date" [(ngModel)]="pt_settings.planning_cycle_date" [min]="utilService.setMinYears()" [max]="utilService.maxDateFilter()">
                                <mat-hint>MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker
                                                disabled
                                                startView="multi-year"
                                                (monthSelected)="setMonthAndYear($event, picker)"
                                                panelClass="example-month-picker">
                                </mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <!-- modal-footer -->
            <div class="modal-footer">
                <button type="button" class="cancel-btn btn btn-default table-submit button_portal mr-3"
                    (click)="closePopup()">{{'lang.common.cancel' | translate}}
                </button>
                <button class="settings-btn btn btn-default table-submit button_portal save-confrim-button"
                    (click)="createScenarioDto()" type="button">{{'lang.common.save' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
<!-- </div> -->
<!---------------------------------------- Rules Violation Popup -------------------------------->
<div class="backdrop" [ngStyle]="{'display': rules_violation_popup}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':rules_violation_popup}">
    <!-- modal-dialog -->
    <div class="modal-dialog modal-dialog-centered rules_popup" role="document">
        <!-- modal-content -->
        <div class="modal-content">
            <!-- modal-header -->
            <div class="modal-header">
                <h4 class="modal-title header_label_portal text-black mt-1 costa_text">
                    {{"lang.scenerio.rule_violation" | translate}}
                </h4>
            </div>

            <!-- If There is No Rule Viaolation -->
            <!-- <div *ngIf="!is_rule_violation" class="modal-body cancelBody">
                <div class="new-pricing">
                    <div class="">
                        {{"lang.scenerio.no_rule_violated" | translate}}
                    </div>
                </div>
            </div> -->

            <!-- If There is Rule Vioalation -->
            <div  class="modal-body cancelBody">
                <div class="new-pricing">
                    <div class="error">
                        <span class="notice">{{"lang.scenerio.rules_violation_notice" | translate}}</span>
                        {{"lang.scenerio.fix_not_possible" | translate}}
                        <div class="filter-field download cursor-pointer" >
                            <div (click)="downloadViolation()"><img src="./../../assets/images/scenerio-planner/download.svg">{{"lang.scenerio.violations_list" | translate}}</div>
                    </div>
                </div>
            </div>
            </div>

            <!-- modal-footer -->
            <div class="modal-footer">
                <button type="button" class="fix-mannually btn btn-default table-submit button_portal mr-3"
                    (click)="closePopup();fixMannually()">{{'lang.scenerio.fix_mannually' | translate}}
                </button>
                <!-- <button (click)="closePopup()" *ngIf="!is_rule_violation" class="settings-btn btn btn-default table-submit button_portal ok-button"
                     type="button">{{'lang.common.proceed' | translate}}
                </button> -->
                <button  class="settings-btn btn btn-default table-submit button_portal ok-button"
                     type="button" (click)="closePopup();overrideViolation()">{{'lang.common.override' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
<!---------------------------------------- Price Hierarchy Popup -------------------------------->

<app-price-hierarchy-popup [price_hierarchy_pop_up_settings]="price_hierarchy_pop_up_settings" (percenatage_data)="getpriceHeirarchyChangedData($event)"> </app-price-hierarchy-popup>

<!-- Reset to Recommended Price popup -->
<div class="backdrop" [ngStyle]="{'display': reset_recommendation_popup}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':reset_recommendation_popup}">
    <!-- modal-dialog -->
    <div class="modal-dialog modal-dialog-centered" role="document">
        <!-- modal-content -->
        <div class="modal-content">
            <!-- modal-header -->
            <div class="modal-header">
                <h4 class="modal-title header_label_portal text-black mt-1 costa_text">
                    {{"lang.scenerio.confirmation" | translate}}
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
                        aria-hidden="true">&times;</span></button>
            </div>

            <!-- modal-body -->
            <div class="modal-body cancelBody">
                <div class="new-pricing">
                    <div class="">
                        {{"lang.scenerio.reset_recommendation" | translate}}
                    </div>
                </div>
            </div>
            <!-- modal-footer -->
            <div class="modal-footer">
                <button type="button" class="cancel-btn btn btn-default table-submit button_portal mr-3"
                    (click)="closePopup()">{{'lang.common.no' | translate}}
                </button>
                <button class="settings-btn btn btn-default table-submit button_portal ok-button"
                    (click)="recalculateImpactDto('recommendation_price','recalculate')" type="button">{{'lang.common.yes' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Reset to Current Price popup -->
<div class="backdrop" [ngStyle]="{'display': reset_current_popup}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':reset_current_popup}">
    <!-- modal-dialog -->
    <div class="modal-dialog modal-dialog-centered" role="document">
        <!-- modal-content -->
        <div class="modal-content">
            <!-- modal-header -->
            <div class="modal-header">
                <h4 class="modal-title header_label_portal text-black mt-1 costa_text">
                    {{"lang.scenerio.confirmation" | translate}}
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
                        aria-hidden="true">&times;</span></button>
            </div>

            <!-- modal-body -->
            <div class="modal-body cancelBody">
                <div class="new-pricing">
                    <div class="">
                        {{"lang.scenerio.reset_current" | translate}}
                    </div>
                </div>
            </div>
            <!-- modal-footer -->
            <div class="modal-footer">
                <button type="button" class="cancel-btn btn btn-default table-submit button_portal mr-3"
                    (click)="closePopup()">{{'lang.common.no' | translate}}
                </button>
                <button class="settings-btn btn btn-default table-submit button_portal ok-button"
                    (click)="recalculateImpactDto('current_price','recalculate')" type="button">{{'lang.common.yes' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>